"use strict";

var debounce = require("lodash/debounce");
var processInclude = require("./util");
var PerfectScrollbar = require("perfect-scrollbar").default;
var perfectScrollbar = null;
var $cache;

$(document).ready(function () {
    processInclude(require("./product/swatch"));
});

const initCache = () => {
    $cache = {
        categoryHeader: $(".c-cat-navigation"),
        categoryNav: $(".c-cat-navigation__subcat-list"),
        categoryNavItems: $(".c-cat-navigation__sub-category"),
        categoryName: $(".c-cat-navigation__name-wrapper"),
        categoriesWrapper: $(".c-cat-navigation__list-wrapper")
    };

    return $cache;
};

// Checks if element is in viewport
$.fn.isInViewport = function () {
    var $this = $(this);
    var elementLeft = $this.offset().left;
    var elementRight = elementLeft + $this.outerWidth();
    var $window = $(window);

    var viewportLeft = $window.scrollLeft();
    var viewportRight = viewportLeft + $window.width();

    return elementRight > viewportLeft && elementLeft < viewportRight;
};

const initCategoryNav = () => {
    $cache.categoryNav.empty().append($cache.categoryNavItems);

    if (window.mqRespond.status.lgDown) {
        var invisibleItems = [];
        var visibleItems = [];
        var invisibleItemsWrap = document.createElement("li");
        var visibleItemsWrap = document.createElement("li");
        var invisibleItemsList = document.createElement("ul");
        var visibleItemsList = document.createElement("ul");

        $(invisibleItemsWrap).addClass("c-cat-navigation__subcat-list--invisible");
        $(visibleItemsWrap).addClass("c-cat-navigation__subcat-list--visible");

        $cache.categoriesWrapper.css("width", "auto");

        $cache.categoryNavItems.each(function (i) {
            var navItem = $cache.categoryNavItems[i];

            if (!$(navItem).isInViewport()) {
                invisibleItems.push(navItem);
            } else {
                visibleItems.push(navItem);
            }
        });

        $(visibleItemsList).append(visibleItems);
        $(visibleItemsWrap).append(visibleItemsList);
        $cache.categoryNav.empty().append(visibleItemsWrap);

        if (invisibleItems.length) {
            $(invisibleItemsList).append(invisibleItems);
            $(invisibleItemsWrap).append(invisibleItemsList);
            $cache.categoryNav.append(invisibleItemsWrap);
        }
    } else {
        var categoryNameWidth = $cache.categoryName.outerWidth();
        var headerWidth = $cache.categoryHeader.outerWidth();

        $cache.categoriesWrapper.css("width", headerWidth - categoryNameWidth - 16);
    }
};

const initPerfectScrollbar = () => {
    if (window.mqRespond.status.lgUp) {
        if (perfectScrollbar == null) {
            perfectScrollbar = new PerfectScrollbar(".c-cat-navigation__list-wrapper");
        } else {
            perfectScrollbar.update();
        }

        setTimeout(function () {
            const $scrollBar = $(".ps__rail-x");

            if ($scrollBar.length > 0) {
                if ($scrollBar.css("width") === "0px" || $scrollBar.css("display") === "none") {
                    $cache.categoriesWrapper.addClass("has-no-active-scroll");
                } else {
                    $cache.categoriesWrapper.removeClass("has-no-active-scroll");
                }
            }
            $cache.categoriesWrapper.css("opacity", "1");
        }, 500);
    } else if (window.mqRespond.status.lgDown && perfectScrollbar != null) {
        perfectScrollbar.destroy();
        perfectScrollbar = null;
    }
};

$(document).ready(function () {
    initCache();
    initCategoryNav();
    setTimeout(() => {
        initPerfectScrollbar();
    }, 1000);

    $(window).on("resize orientationchange", () => {
        if (window.mqRespond.status.lgUp) {
            $cache.categoriesWrapper.css("opacity", "0");
        } else {
            $cache.categoriesWrapper.css("opacity", "1");
        }
    });

    $(window).on("resize orientationchange", debounce(function () {
        $cache.categoriesWrapper.scrollLeft(0);
        initCategoryNav();
        initPerfectScrollbar();
    }, 500));
});
